import Classy from '@meteora-digital/classy';
export default class Watcher extends Classy {
  constructor() {
    super();
    // The items already being watched
    this.cache = [];
    // The selector we will use to find lazy elements
    this.selectors = [];
    // Some throttles / timeouts
    this.timeouts = {};
    // The watcher ID
    this.id = new Date().getTime();

    // Set up a mutation observer to watch for new elements
    this.MutationObserver = new MutationObserver(() => this.update());

    // Observe the entire document
    this.MutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  watch() {
    let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // if the argument is a string, use it as a selector
    if (typeof selector === 'string') {
      // Update the selectors
      if (this.selectors.indexOf(selector) === -1) {
        this.selectors.push(selector);
        this.update();
      }
      ;
    }
    this.callback('watch', this.selectors);
  }
  update() {
    // Clear the update timeout
    clearTimeout(this.timeouts['update']);

    // An array of new items on the page
    let items = [];

    // Set the update timeout
    this.timeouts['update'] = setTimeout(() => {
      // If there are no selectors, return
      if (!this.selectors.length) return;

      // Loop through all the elements on the page that match the selector
      [...document.querySelectorAll(this.selectors.join(','))].forEach(element => {
        // If this element is already being watched, return
        if (this.cache.includes(element)) return;

        // Add the element to the list of items
        items.push(element);
      });

      // If there are no new items, return
      if (!items.length) return;

      // Add the new items to the list of items
      this.cache = [...this.cache, ...items];

      // Filter only the new items that are currently on the page
      items = items.filter(item => document.body.contains(item));

      // Return the new items
      this.callback('update', items);
    }, 100);
  }
}